// 공정 초안 일수 — 수량(m²) ÷ (인원 × 1인1일 작업량) × 회사 계수 → 0.5일 단위 올림 · 최소 1일 · 1명 기준 같이(#171) · 일정표 정수 일수는 올림.

export interface DraftDaysInput {
  quantityM2: number;
  crew: number;
  outputPerPersonDay: number;
  factor: number;
}

export interface DraftDays {
  crewDays: number;
  soloDays: number;
  durationDays: number;
}

export class DraftDaysInputError extends Error {
  constructor(readonly field: keyof DraftDaysInput) {
    super(`공정 일수 입력이 올바르지 않습니다: ${field}`);
    this.name = "DraftDaysInputError";
  }
}

// 부동소수 꼬리(2.0000000001)가 반 칸 더 올리지 않게 백만분의 일에서 자른 뒤 올린다.
export const ceilHalfDay = (days: number): number => Math.max(1, Math.ceil(Math.round(days * 2 * 1e6) / 1e6) / 2);

const positive = (value: number): boolean => Number.isFinite(value) && value > 0;

export const draftDays = (input: DraftDaysInput): DraftDays => {
  if (!positive(input.quantityM2)) throw new DraftDaysInputError("quantityM2");
  if (!Number.isInteger(input.crew) || input.crew < 1) throw new DraftDaysInputError("crew");
  if (!positive(input.outputPerPersonDay)) throw new DraftDaysInputError("outputPerPersonDay");
  if (!positive(input.factor)) throw new DraftDaysInputError("factor");
  const solo = (input.quantityM2 / input.outputPerPersonDay) * input.factor;
  const crewDays = ceilHalfDay(solo / input.crew);
  return { crewDays, soloDays: ceilHalfDay(solo), durationDays: Math.ceil(crewDays) };
};
